<template>
    <!-- 司机-优享券-详情 -->

    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="95%" :before-close="closeDialog">
        <div>
            <div class="handle-box-search">
                <div class="handle-box">
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">司机电话号:</span>
                            <!-- 搜索司机电话号 -->
                            <el-input
                                v-model="search_data.driver_phone"
                                placeholder="请输入司机电话号"
                                class="handle-input mr10"
                                @keyup.enter.native="searchPriorityDetailsLists"
                            ></el-input>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">状态:</span>
                            <el-select v-model="search_data.use_status" placeholder="请选择" clearable style="width: 150px">
                                <el-option label="封禁" value="0"> </el-option>
                                <el-option label="启用" value="1"> </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">司机姓名:</span>
                            <!-- 搜索司机姓名 -->
                            <el-input
                                v-model="search_data.driver_name"
                                placeholder="请输入司机姓名"
                                class="handle-input mr10"
                                @keyup.enter.native="searchPriorityDetailsLists"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>

                <el-button type="primary" icon="el-icon-search" @click="searchPriorityDetailsLists">搜索</el-button>
                <!-- <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button> -->
                <el-button type="primary" @click="priorityBanAll">一键封禁</el-button>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="phone" label="司机电话" min-width="100"> </el-table-column>
            <el-table-column prop="name" label="司机姓名" min-width="100"> </el-table-column>

            <el-table-column prop="use_status.alias" label="使用状态" min-width="60"> </el-table-column>

            <el-table-column prop="exp_date_time.YmdHis" label="到期时间" min-width="100"> </el-table-column>

            <el-table-column prop="send_time.YmdHis" label="发放日期" min-width="160"> </el-table-column>

            <el-table-column prop="use_time.YmdHis" label="使用日期" min-width="200"> </el-table-column>
            <el-table-column label="备注" prop="remark" min-width="100"> </el-table-column>

            <el-table-column width="100" label="操作">
                <template slot-scope="scope">
                    <el-switch
                        :class="{
                            'pri-switch-close': scope.row.use_status.val == 0 || scope.row.use_status.val == 3,
                            'pri-switch-open': scope.row.use_status.val == 1
                        }"
                        v-if="scope.row.use_status.val != 2 && scope.row.use_status.val != 3"
                        v-model="scope.row.use_status.val"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                        @change="executePriority(scope.row)"
                    >
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
let _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data.priority_mode_code = _this.data;

            _this.searchPriorityDetailsLists();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,

            search_data: {
                page: 1,
                limit: 10,
                priority_mode_code: '',
                driver_name: '',
                driver_phone: '',
                use_status: ''
            },
            search_data_execute: {
                driver_priority_record: '',
                priority_mode_code: '',
                driver_code: '',
                use_status: ''
            },

            tableData: [],
            result_data: {}
        };
    },
    methods: {
        // 一键封禁
        priorityBanAll() {
            _this
                .$post('/priority/priorityBanAll', { priority_mode_code: _this.search_data.priority_mode_code })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.searchPriorityDetailsLists();
                })
                .catch((err) => {});
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.tableData = [];
            _this.search_data_execute = {
                driver_priority_record: '',
                priority_mode_code: '',
                driver_code: '',
                use_status: ''
            };
            _this.search_data = {
                page: 1,
                limit: 10,
                priority_mode_code: '',
                driver_name: '',
                driver_phone: '',
                use_status: ''
            };
        },
        // 优享券启用禁用开关
        executePriority(val) {
            console.log(val, 'val====');

            _this.search_data_execute.driver_priority_record = val.driver_priority_record;
            _this.search_data_execute.priority_mode_code = val.priority_mode_code;
            _this.search_data_execute.driver_code = val.driver_code;

            _this.search_data_execute.use_status = val.use_status.val;

            _this
                .$post('/priority/executePriorityStatusSubmit', _this.search_data_execute)
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.priorityDetailsLists();
                })
                .catch((err) => {});
        },
        // 列表
        priorityDetailsLists() {
            _this.$post('/priority/priorityDetailsLists', _this.search_data).then((res) => {
                _this.result_data = res;
                _this.tableData = res.data;
            });
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            // console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.priorityDetailsLists();
        },
        searchPriorityDetailsLists() {
            _this.search_data.page = 1;
            _this.priorityDetailsLists();
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
<style>
.pri-switch-close .el-switch__core::after {
    content: '关';
    font-size: 10px;
    text-align: center;
    line-height: 16px;
    color: #ff4949;
}

.pri-switch-open .el-switch__core::after {
    content: '开';
    font-size: 10px;
    text-align: center;
    line-height: 16px;
    color: #13ce66;
}
</style>
